import BackButton from "../../shared/buttons/BackButton"
import Layout from "./Layout"
import { Box, Typography, Link } from "@mui/material"

const TermsAndConditions = () => {
  return (
    <Layout>
      <BackButton />
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
        Privacy Policy
      </Typography>
      <Typography variant="body1" component="p">
        «Call4Life Solutions» FZCO, (“CALL4LIFE”, “we”, “our” or “us”) undertakes to respect the
        confidentiality and security of your personal information. This privacy policy on the
        Internet (the “Privacy Policy”) describes the information we collect when you access or use
        our mobile and web applications called “Call4life” (the “Application”) or online and offline
        services that we provide In connection with the use of the application (the “Services”)
        .When you download, access or use the application, or otherwise use the Services, you agree
        to this Privacy Policy.
      </Typography>

      <Typography variant="body1" component="p" sx={{ mt: 1 }}>
        We may periodically update this privacy policy to reflect significant changes in the way we
        collect, use or store your personal information. We recommend that you follow the updates to
        this privacy policy on an ongoing basis in order to be aware of the changes. You agree to
        any changes we make to this privacy policy if you continue to access or use the application
        or website after receiving notice of a change or after our posting of the new privacy policy
        in this statement.
      </Typography>
      <Typography sx={{ mt: 2, mb: -1 }}>This privacy policy informs you of:</Typography>
      <Box component="ul">
        <Typography component="li" variant="body1">
          Personal information that we collect and how we collect it;
        </Typography>

        <Typography component="li" variant="body1">
          How we use personal information;
        </Typography>

        <Typography component="li" variant="body1">
          How we protect your personal information;
        </Typography>

        <Typography component="li" variant="body1">
          Practice with regard to children’s information;
        </Typography>

        <Typography component="li" variant="body1">
          Participation of third parties;
        </Typography>

        <Typography component="li" variant="body1">
          How you can access and change the personal information we store about you;
        </Typography>

        <Typography component="li" variant="body1">
          How you can contact us for questions or problems.
        </Typography>
      </Box>

      <Typography sx={{ mb: 2 }}>
        As used in this privacy policy, the term “personal information” means information that has
        allowed you to be identified, including, for example, your full name, address, phone number
        and email address.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
        Collection of information
      </Typography>
      <Typography sx={{ mb: -1 }}>Below are the types of information we collect:</Typography>
      <Box component="ul">
        <Typography component="li" variant="body1">
          We receive and safely store the information you provide to us at registration. This
          information includes such items as your name, e-mail address, phone number, address, date
          of birth, sex, language. If you provide information in other ways, for example by sending
          us an email or via online chat, we can save this information and add it to other available
          information about you.
        </Typography>
        <Typography component="li" variant="body1">
          Automatically collected information. We can receive and store certain types of information
          about you every time you use the application, website or other our service. For example,
          we can automatically collect data about the type of your browser, language, date, duration
          of your session, the address of your Internet Protocol (IP). The technologies that we use
          for automatic data collection can include:
        </Typography>
        <Box component="ul">
          <Typography component="li" variant="body1">
            Cookies. Cookies are small data files that are stored on a hard disk using a website.
            Among other things, “cookies” will help us improve your experience of using our
            services. You can configure your browser not to accept “cookies,” but remember that if
            you visit other websites, you may be required to accept “cookies.” The use of “cookies”
            by third parties is not covered by our privacy policy. We do not have access or control
            over these “cookies”.
          </Typography>
          <Typography component="li" variant="body1">
            Web beacons. Web beacons are electronic images that can be used in our services, as well
            as in our e-mails. We use web beacons to accept cookies, count visits, evaluate usage
            and efficiency, and get information about opening and delivering a message.
          </Typography>
          <Typography component="li" variant="body1">
            Others. We can also use GIF images or other data files, identifiers to collect
            statistical information, as well as improve and develop the services that we provide.
            GIF files with a unique identifier, similar in function to cookies. Unlike “cookies”,
            which are placed on the hard drive, GIF-files are built-in on web pages.
          </Typography>
        </Box>
      </Box>

      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
        Use and disclosure of information
      </Typography>
      <Typography sx={{ mb: -1 }}>
        We may only use your personal information as described in this privacy policy. For example,
        we may use your personal information:
      </Typography>
      <Box component="ul">
        <Typography component="li" variant="body1">
          To manage and improve our services;
        </Typography>
        <Typography component="li" variant="body1">
          In order to better understand your needs and provide you with a more personalized service;
        </Typography>
        <Typography component="li" variant="body1">
          In order to communicate with you about our services;
        </Typography>
        <Typography component="li" variant="body1">
          In order to answer your questions and help solve problems;
        </Typography>
        <Typography component="li" variant="body1">
          To record information about your session;
        </Typography>
        <Typography component="li" variant="body1">
          For market research, project planning, troubleshooting and troubleshooting, detection and
          protection against errors, fraud or other criminal activities;
        </Typography>
        <Typography component="li" variant="body1">
          For our companies and branches in other countries;
        </Typography>
        <Typography component="li" variant="body1">
          Third parties in connection with any merger, acquisition, reorganization, changes in the
          capital structure or sale of all, or virtually all of CALL4LIFE’s assets;
        </Typography>
        <Typography component="li" variant="body1">
          For service providers appointed, appointed with your consent.
        </Typography>
      </Box>
      <Typography sx={{ mb: 1 }}>
        When there are the basic bases that the disclosure of information is required for the
        compliance of the law, protection or protection of our rights or the rights of other users
        of our appendices or other services, and also in the emergency situation for the protection
        of your safety.
      </Typography>
      <Typography>
        We can create anonymous data from the information we collect. we can use anonymous data for
        our own goals or disclose to its third persons by own discretion.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
        Data protection
      </Typography>
      <Typography>
        We accept reasonable measures to help to protect your personal information for prevention of
        loss, misuse, unauthorized access, disclosure, modification and destruction. We follow the
        generalized standards for protection of personal information, as during transmission, so and
        when receiving. Then, not one of the methods of transferring data through the internet or
        the method of electronic storage is 100% safe, and we can not guarantee absolute security.
        Please contact us if you have any questions about the safety of our application and other
        services.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
        Returns
      </Typography>
      <Typography>
        If you are not satisfied with Call4life’s services, you can return the cost spent on the
        service. In order to be eligible for a refund, you must send us a request, accompanied by a
        reasoned justification for a refund, within the first 24 hours from the date of purchase.
        Your request will be reviewed by our customer support within 14 days. To complete the
        refund, we will require a receipt or proof of purchase. Once your application will be
        received and verified, we will send you a confirmation email. We will also notify you of
        approval or rejection of a refund. If more than 24 hours passed since your purchase, then,
        unfortunately, your request for refund will be denied.
      </Typography>
      <Typography component="span" sx={{ mt: 1 }}>
        Not received refunds. If your application was approved, but you have not received your
        refund, you must verify your bank account again. Contact your bank and ask for further
        information. It may take some time before the money transfer is officially executed by the
        bank. If the bank could not help you, and you still have not received a refund, please
        contact us at
      </Typography>
      <Link href="mailto:info@call4life.net" sx={{ ml: 1 }}>
        info@call4life.net
      </Link>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
        Retention period
      </Typography>
      <Typography>
        We collect and keep data on our customers. Retention period of this data is equal to 6
        months. Our customers’ private data is not a subject to transfer to any third party.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
        Practice for children
      </Typography>
      <Typography component="span">
        Our appendix and service are not intended for children age up to 18 years. Nobody just 18
        years cannot give any information to any of the application or other our services. We do not
        assume personal information in children age up to 18 years. If you are 18 years period, you
        should not use or grant any information in our app any or other services. If we learn that
        we have asseted or received personal information from the child at age up to 18 years
        without verification of parent concentration, we will delete this information. If you
        consider that we may have any information about the child until 18 years, please contact us
        at
      </Typography>
      <Link href="mailto:info@call4life.net" sx={{ ml: 1 }}>
        info@call4life.net
      </Link>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
        Third parties
      </Typography>
      <Typography>
        Advertising and links to other sites: the appendix may contain links, content and
        advertising from third parties. Such links and advertising announcements do not confirm or
        certify about our accessories to this third party. We are not responsible for the privacy
        policy of third parties, and we recommend reading carefully with the privacy policy of any
        web service which you visiting.
      </Typography>
      <Typography sx={{ mt: 1 }}>
        Advertising agencies, ad networks, and other companies that may place advertising on our
        applications can use their own “cookies”, pixel tags, web beacons and other technologies to
        collect information about you. We do not control use of such technology in these companies
        and we do not assume any responsibility for the use of these technologies to collect
        information about you.
      </Typography>
      <Typography sx={{ mt: 1 }}>
        When using Call4life services User agrees, that his data might be transferred and used by
        third parties in order to improve quality of life.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
        How to view, change or delete information
      </Typography>
      <Typography sx={{ mb: -1 }}>
        We are glad to inform you our news and news with you dialogue, only if the condition that
        you want it. If you do not wish to receive any information or would like to update or change
        your personal information or preferences, follow the instructions below for review, change
        or delete your personal information.
      </Typography>
      <Box component="ul">
        <Typography component="li" variant="body1">
          To change the information you have provided during registration, please log in and update
          your personal settings;
        </Typography>

        <Typography component="li" variant="body1">
          To unsubscribe from an email, please follow the instructions in any email that you
          received.
        </Typography>
      </Box>
      <Typography>
        If you want to delete your registration data or unsubscribe from, we shall fulfill your
        request, but we can keep information about you for internal record keeping.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
        DPA claims
      </Typography>
      <Typography>
        Any customers that is not satisfied with our services and have reasonable objections or
        complaints may file a claim to the applicable court of Armenia.
      </Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
        Sensitive Personal Data
      </Typography>
      <Typography sx={{ mb: -1 }}>
        We deeply understand that we should protect our customers’ sensitive personal data which
        includes:
      </Typography>
      <Box component="ul">
        <Typography component="li" variant="body1">
          (a) the racial or ethnic origin of the data subject;
        </Typography>
        <Typography component="li" variant="body1">
          (b) his political opinions;
        </Typography>
        <Typography component="li" variant="body1">
          (b) his political opinions;
        </Typography>
        <Typography component="li" variant="body1">
          (c) his religious beliefs or other beliefs of a similar nature;
        </Typography>
        <Typography component="li" variant="body1">
          (d) whether he is a member of a trade union;
        </Typography>
        <Typography component="li" variant="body1">
          (e) his physical or mental health or condition;
        </Typography>
        <Typography component="li" variant="body1">
          (f) his sexual life;
        </Typography>
        <Typography component="li" variant="body1">
          (g) the commission or alleged commission by him of any offence; or
        </Typography>{" "}
        <Typography component="li" variant="body1">
          (h) any proceedings for any offence committed or alleged to been committed by him, the
          disposal of such proceedings or the sentence of any court in such proceedings.
        </Typography>
      </Box>
      <Typography>We provide our customers with the proper protection of these data.</Typography>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 2, mb: 1 }}>
        Questions, feedback and complaints
      </Typography>

      <Typography component="span" sx={{ mt: 1 }}>
        We welcome your questions, comments on confidentiality. If you have a complaint about a
        privacy violation, please contact us by e-mail at:
      </Typography>
      <Link href="mailto:info@call4life.net" sx={{ ml: 1 }}>
        info@call4life.net
      </Link>
      <Box sx={{ mt: 1 }} />

      <Typography component="span">You may contact our DPO officer by e-mail at:</Typography>
      <Link href="mailto:info@call4life.net" sx={{ ml: 1 }}>
        info@call4life.net
      </Link>

      <Box sx={{ mb: 4 }} />
    </Layout>
  )
}

export default TermsAndConditions
